<div class="page-layout">
  @if (icon() || title()) {
    <div
      class="page-layout-header justify-content-space-between px-medium py-pony border-color-air {{ headerClasses() }}"
      [ngClass]="{ 'border-b-300': showBorder() }"
    >
      <div class="page-layout-header-section d-flex align-items-center justify-content-start h-100">
        @if (showBackIcon()) {
          <div
            class="page-layout-header-action ml-medium"
            (click)="handleActionClick()"
          >
            <div class="page-layout-header-action-icon">
              <common-icon-dp-icon
                [classes]="'text-onback-high'"
                [iconSize]="'24'"
                [iconType]="'linear'"
                [icon]="icon() || 'arrow-right'"
              ></common-icon-dp-icon>
            </div>
          </div>
        }
        @if (title()) {
          <div class="page-layout-header-title t-6 text-onback-high">
            {{ title() }}
          </div>
        }
      </div>
      <div class="page-layout-header-section">
        <div class="page-layout-header-secondary-action">
          <ng-content select="[secondaryAction]"></ng-content>
        </div>
      </div>
    </div>
  }
  <div
    id="dpx-page-layout-body"
    class="page-layout-body d-flex flex-column {{ bodyClasses() }}"
    #pageBody
    [ngStyle]="bodyStyle()"
    (scroll)="handleScroll($event)"
    [ngClass]="{ sticky: stickyHeader() }"
  >
    <ng-content></ng-content>
  </div>
</div>
